// Display formats (SW-GE-03, SW-GE-04). Dates shown in Europe/Paris.
export const TZ = "Europe/Paris";

const dateFmt = new Intl.DateTimeFormat("fr-FR", {
  timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
});
const timeFmt = new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, hour: "2-digit", minute: "2-digit" });

/** "03/10/2026 14:37" */
export function formatDateTime(iso: string | Date): string {
  return dateFmt.format(typeof iso === "string" ? new Date(iso) : iso).replace(",", "");
}

export function formatTime(iso: string | Date): string {
  return timeFmt.format(typeof iso === "string" ? new Date(iso) : iso);
}

/** metres under 1 km, then km with one decimal: "350 m", "4,4 km" */
export function formatDistance(m: number): string {
  if (m < 1000) return `${Math.round(m)} m`;
  return `${(m / 1000).toFixed(1).replace(".", ",")} km`;
}

/** "9 min 30 s", "45 s", "1 h 05 min" */
export function formatDuration(s: number): string {
  const total = Math.round(s);
  if (total < 60) return `${total} s`;
  const h = Math.floor(total / 3600);
  const min = Math.floor((total % 3600) / 60);
  const sec = total % 60;
  if (h > 0) return `${h} h ${String(min).padStart(2, "0")} min`;
  return sec === 0 ? `${min} min` : `${min} min ${sec} s`;
}

/** "3,20 m" */
export function formatHeight(m: number): string {
  return `${m.toFixed(2).replace(".", ",")} m`;
}

/** Offset of Europe/Paris from UTC at the given instant, in minutes. */
function parisOffsetMin(ms: number): number {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit",
  }).formatToParts(new Date(ms));
  const v = (t: string) => Number(parts.find((p) => p.type === t)!.value);
  const asUtc = Date.UTC(v("year"), v("month") - 1, v("day"), v("hour"), v("minute"), v("second"));
  return Math.round((asUtc - ms) / 60000);
}

/** UTC instant -> "2026-07-14T18:30" in Paris time, for <input type="datetime-local"> */
export function toParisInput(iso: string): string {
  const ms = Date.parse(iso);
  const local = new Date(ms + parisOffsetMin(ms) * 60000);
  return local.toISOString().slice(0, 16);
}

/** "2026-07-14T18:30" in Paris time -> UTC ISO string */
export function fromParisInput(value: string): string {
  const naive = Date.parse(value + ":00Z");
  // two passes handle the daylight saving changes
  let ms = naive - parisOffsetMin(naive) * 60000;
  ms = naive - parisOffsetMin(ms) * 60000;
  return new Date(ms).toISOString();
}
